import React, { useEffect, useState } from 'react';
import '../css/Auth.css';
import { Link } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { useNavigate } from 'react-router-dom';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { loginUser, user } = useUser();

  const handleUserEmailUpdate = (userEmail: string) => {
    event?.preventDefault();
    setEmail(userEmail);
  };

  const handleUserPasswordUpdate = (userPassword: string) => {
    event?.preventDefault();
    setPassword(userPassword);
  };

  const handleLogin = (email: string, password: string) => {
    event?.preventDefault();

    try {
      loginUser(email, password);
      // navigate('/');
    } catch (error) {
      console.log('AN ERROR HASS OCCURED IN LOGIN', error);
    }
    console.log('USER FROM HANDLE LOGIN', user);
  };

  return (
    <div className="auth-form-container">
      <p className="auth-form-title">Login</p>
      <form
        className="auth-form"
        onSubmit={() => {
          handleLogin(email, password);
        }}
      >
        <label className="auth-form-input-label">
          Email
          <input
            className="auth-form-input"
            value={email}
            onChange={(e) => handleUserEmailUpdate(e.target.value)}
          ></input>
        </label>
        <label className="auth-form-input-label">
          Password
          <input
            className="auth-form-input"
            value={password}
            onChange={(e) => handleUserPasswordUpdate(e.target.value)}
            type={'password'}
          ></input>
        </label>
        <button role="button" className="auth-form-submit-button">
          Login
        </button>
      </form>
      <Link to="/register">Click Here To Register</Link>
    </div>
  );
}

export default Login;
